"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { mapProductToGA4Item, pushDataLayer, type ProductForGA4 } from "@/lib/gtm";

interface Props {
  href: string;
  className?: string;
  listId: string;
  listName: string;
  product: ProductForGA4;
  index: number;
  children: ReactNode;
}

/**
 * Wrapper autour de <Link> qui pousse select_item au clic puis laisse la navigation suivre.
 */
export function SelectItemLink({ href, className, listId, listName, product, index, children }: Props) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() => {
        pushDataLayer("select_item", {
          item_list_id: listId,
          item_list_name: listName,
          items: [mapProductToGA4Item(product, index)],
        });
      }}
    >
      {children}
    </Link>
  );
}
